module.exports = __webpack_public_path__ + "static/img/sf-logo.2265e9cd.png";